import { FilterService } from '@app/core/services/container/filter.service';
import { Constants } from '@app/shared/constants';
import { SortParam } from '@app/shared/models/page.interface';
import { StateService } from '@app/shared/services/state-service.interface';
import { Injectable } from "@angular/core";

/**
 * This class will help to get different states of the application.
 */
@Injectable()
export class StateFactoryService {
  /**
   * Get the initial page for a datatable
   *
   * @param service the service that contains the state
   * @param dataTableId optional data table id
   * @return the initial page
   */
  getInitialPage(service: StateService<any>, dataTableId?: string): string {
    let initialPage = Constants.DATATABLE_INITAL_PAGE;
    let state = service.getDataTableState(dataTableId);
    if (state && state.currentIndex) {
      initialPage = state.currentIndex.toString();
    }
    return initialPage;
  }

  /**
   * Get the initial items x page size for a datatable
   *
   * @param service the service that contains the state
   * @param dataTableId optional data table id
   * @return the initial page
   */
  getInitialPageSize(service: StateService<any>, dataTableId?: string): string {
    let initialPageSize = Constants.DATATABLE_PAGE_SIZE;
    let state = service.getDataTableState(dataTableId);
    if (state && state.currentSize) {
      initialPageSize = state.currentSize.toString();
    }
    return initialPageSize;
  }

  /**
   * Get the sorting info for a datatable
   *
   * @param service the service with the state
   * @param defaultField defaul field id
   * @param dataTableId optional data table id
   * @return the sorting info
   */
  getSort(service: StateService<any>, defaultField: string, dataTableId?: string): SortParam[] {
    let sort: SortParam = { field: defaultField, direction: Constants.ASC_DIR };
    let state = service.getDataTableState(dataTableId);
    if (state && state.sort) {
      sort = state.sort;
      if (sort.field === '') {
        sort.field = defaultField;
      }
    }
    return [sort];
  }

  /**
   * Get the applied filters in a datatable
   *
   * @param service the service with the state
   * @param filterService an instance of the FilterService class
   * @return the applied filters
   */
  getAppliedFilters(service: StateService<any>, filterService: FilterService, dataTableId?: string): string {
    let appliedFilters = '';
    if (service.getFilterState()) {
      appliedFilters = filterService.getStateFilters(service.getFilterState(dataTableId));
    }
    return appliedFilters;
  }
}
